import { TextField, useMediaQuery, useTheme } from "@mui/material/";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import { useState } from "react";
import SimpleInputForm from "./SimpleInputForm";
import SimpleSelectForm from "./SimpleSelectForm";
export const QuoteDialog = ({ state, close, toggle, productData }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const [values, setValues] = useState({
    name: "",
    email: "",
    service: "",
  });
  const handleValuesChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };
  return (
    <Dialog
      open={state}
      variant="standard"
      disableEscapeKeyDown={true}
      disableEnforceFocus
      onClose={close}
      maxWidth={"lg"}
      fullScreen={fullScreen}
      fullWidth={true}
      PaperProps={{
        style: {
          borderRadius: "0px",
          background: "transparent",
          margin: 0,
          boxShadow: "none",
        },
      }}>
      <div
        className={`text-1  flex h-full justify-center text-neutral-1 
       md:items-center lg:rounded-lg`}>
        {" "}
        <div className="w-full max-w-lg rounded-lg  bg-white p-8  ">
          <div className="flex items-start justify-between mb-8 gap-4">
            <div className="flex flex-col gap-2">
              <h2 className="text-2xl font-semibold text-neutral-2 ">
                Get an Estimate
              </h2>
              <p className="text-neutral-2 text-sm">
                Complete the form below and a representative will be in contact
                with you soon!
              </p>
            </div>
            <IconButton
              aria-label="close"
              name="share"
              onClick={(e) => toggle(e)}>
              <CloseIcon />
            </IconButton>
          </div>
          <div
            onSubmit={() => console.log("ok")}
            className="flex flex-col gap-8">
            <div className="flex w-full flex-col gap-4 sm:gap-4">
              <div className="col-12 col-lg-6 w-full">
                <SimpleInputForm
                  value={values.first_name}
                  name="name"
                  label="Name*"
                  placeholder={"Enter your name"}
                  onChange={handleValuesChange}
                />
              </div>
              <div className="col-12 col-lg-6 w-full">
                <SimpleInputForm
                  value={values.email}
                  name="email"
                  label="Email*"
                  placeholder={"Enter your email address"}
                  type="email"
                  onChange={handleValuesChange}
                />
              </div>{" "}
              <div className="col-12 col-lg-6 w-full">
                <SimpleInputForm
                  value={values.phone}
                  name="address"
                  label="Address*"
                  placeholder={"Enter your address"}
                  type="text"
                  onChange={handleValuesChange}
                />
              </div>
              <div className="col-12 col-lg-6 w-full">
                <SimpleSelectForm
                  value={values.how_referred}
                  name="service"
                  label="Service Needed"
                  placeholder={"Select an option"}
                  options={[
                    "Lanscaping",
                    "Lawn Care",
                    "Tree Services",
                    "Irrigation",
                  ]}
                  onChange={handleValuesChange}
                />
              </div>
              <div className="col-12 col-lg-6 w-full">
                <TextField
                  label="Message(optional)"
                  placeholder="Type your message here"
                  multiline
                  rows={4}
                  defaultValue=""
                  className="w-full"
                />
              </div>
            </div>

            <button
              type="submit"
              // onClick={() => setStep(2)}
              className="btn btn-main btn-large text-base"
              to={"congrats"}>
              Submit
            </button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default QuoteDialog;
